import { Fragment } from 'react';
import clsx from 'clsx';
import { ActiveLink, Picture, Button, Control } from '@/components';
import getLinkProps from '@/lib/getLinkProps';

import styles from '../Shop.module.scss';

const RowShop = props => {
	const { address, phones, store_hours, image, latitude } = props;
	const [shopsMapHref, shopsMapAs] = getLinkProps({ type: 'shops-map' });

	return (
		<div className={clsx(styles.row, styles.sideShop)}>
			<div className={styles.img}>
				<Picture {...image} />
			</div>
			<div className={clsx(styles.prop, styles.address)}>{address}</div>
			<div className={clsx(styles.prop, styles.phoneWrapp)}>
				{phones.map((phone, ind) => {
					const { normal, prettified } = phone;
					return (
						<Fragment key={normal}>
							<a className={styles.phone} href={`tel:${normal}`}>
								{prettified}
							</a>
							{phones.length > 1 && ind < phones.length - 1 && ', '}
						</Fragment>
					);
				})}
			</div>
			<div className={clsx(styles.prop, styles.hours)}>
				{store_hours.map(data => (
					<p key={data}>{data}</p>
				))}
			</div>

			<ActiveLink
				href={{ pathname: shopsMapHref, query: { latitude } }}
				as={{ pathname: shopsMapAs, query: { latitude } }}
			>
				<Control className={styles.linkWrapp}>
					<Button classNames={{ general: styles.link }} action='button' type='link'>
						На карте
					</Button>
				</Control>
			</ActiveLink>
		</div>
	);
};

export default RowShop;
